import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_RETURN_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the return fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemReturnFeeMaybe = props => {
  const { lineItems, intl } = props;

  const returnFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_RETURN_FEE && !item.reversal
  );

  return returnFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.returnFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, returnFeeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemReturnFeeMaybe;
